// NATIVE 
import { useEffect, useState } from 'react';

// INSTALLED 
import { useDispatch, useSelector } from 'react-redux';
import { Chip, Grid, IconButton, Stack, Tooltip, Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions, 
  Button} from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

// CUSTOM 
import InputField from 'components/formFields/InputField';
// import { getFormsDataS } from 'store/company';
import InputNumeric from 'components/formFields/InputNumeric';
import CheckboxField from 'components/formFields/checkBoxField';
import { IDatosBasicos } from 'commons/interfaces';
import AutocompleteField from 'components/formFields/autocompleteField';
import DatePickerDefaultField from 'components/formFields/datePickerDefaultField';
import AutocompleteFieldCountry from 'components/formFields/autocompleteFieldCountry';
import AutocompleteFieldDepartament from 'components/formFields/AutocompleteFieldDepartament';
import { useFormikContext } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { addApplicationToCustomer, removeApplicationCustomer, storeGetDetailCustomer } from 'store/customer';
import { SnackAlert } from 'components/SnackAlert';
import { useResponseHandler } from '../../../../../hooks/useResponseHandler';
import AutocompleteMultiple from 'components/formFields/AutocompleteMultiple';


// import InputNumeric from '../formFields';

export const EditarDatosClientes = (props:any) => {


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formikProps:any = useFormikContext();

    // REDUX
    const { countries_list }:IDatosBasicos  = useSelector( (state:any) => state.company );
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );
    
    // REDUX 
    const { customer, applicationsListSelect }:any  = useSelector( (state:any) => state.customer );


    const [countries,      setCountries]     = useState([]);
    const [departaments,   setDepartaments]  = useState([]);
    const [municipalies,   setMunicipalies]  = useState([]);

    const [percentaje, setPercentaje] = useState(2);

    const [open, setOpen] = useState(false);

    const [applicationsListSelectFormated,   setApplicationsListSelectFormated]  = useState([]);
    

    const [customerApplications,   setCustomerApplications]  = useState([]);
    const [customerApplicationsSelect,   setCustomerApplicationsSelect]  = useState([]);
    const [allApplicationsSelect, setAllApplicationsSelect] = useState([]); // lista original sin filtrar

    const [applicationRemoveId,   setApplicationRemoveId]  = useState('');

    const [btnAddApplication,   setBtnAddApplication]  = useState(false);

    const { id: customerId }: any = useParams();
    const { handleResponse, ResponseComponents } = useResponseHandler();

    const { formField: {
        // DATOS CLIENTE 
        e_name,
        e_address,
        e_email,
        e_person_in_charge,
        e_contact,
        e_second_person_in_charge,
        e_second_customer_contact,
        e_phone,
        e_start_date,
        e_status,
        e_country,
        e_departament,
        e_municipaly,
        e_applications,
        e_subscription_ends_at
      }
    } = props;



     useEffect(() => {
        detalleCustomer();
    }, [])

    const detalleCustomer = async() => {
      if (!customerId) return;
      const response = await dispatch(storeGetDetailCustomer(customerId));
      await handleResponse(response, 'Detalle cargado', false);
      
    }

    useEffect(() => {
        getDataInputesForm();
     }, []);
 
 
     useEffect(() => {
       setDepartaments(departaments_list);
     }, [departaments_list]);
 
     useEffect(() => {
       setMunicipalies(municipaly_list);
     }, [municipaly_list]);


     const getDataInputesForm = async () => {

        // const response = await dispatch( getFormsDataS() );

        
        setCountries([]);
        setDepartaments([]);
        setMunicipalies([]);
    }


    useEffect(() => {
        setData(customer);
    }, [customer]);



    const setData = async(customer:any) => {



      // ID CUSTOMER 
      formikProps.setFieldValue('customerId', customer.id );

      // DATOS BASICOS
      formikProps.setFieldValue('e_name', customer.name);
      formikProps.setFieldValue('e_address', customer.address );
      formikProps.setFieldValue('e_email', customer.email );
      formikProps.setFieldValue('e_person_in_charge', customer.person_in_charge );
      formikProps.setFieldValue('e_contact', customer.contact );
      formikProps.setFieldValue('e_second_person_in_charge', customer.second_person_in_charge );
      formikProps.setFieldValue('e_second_customer_contact', customer.second_customer_contact );
      formikProps.setFieldValue('e_phone', customer.phone );
      formikProps.setFieldValue('e_start_date', customer.start_date );
      formikProps.setFieldValue('e_status', customer.status );
      formikProps.setFieldValue('e_country', customer.pais );
      formikProps.setFieldValue('e_departament', customer.departamento );
      formikProps.setFieldValue('e_municipaly', customer.municipio );
      formikProps.setFieldValue('e_subscription_ends_at', customer.subscription_ends_at || customer.trial_ends_at || null);

       await setCustomerApplicationsSelect(customer.applicationsForSelect || []); // guardas la copia original
       await setAllApplicationsSelect(customer.applicationsForSelect || []); // también para renderizar

       await setCustomerApplications(customer.applications || []);
      
      
    }


    useEffect(() => {
      if ( customerApplications.length > 0 || customerApplicationsSelect.length > 0 ) {
          removeExistingAppsFromSelect();
      }
    }, [customerApplications])
    

    const removeExistingAppsFromSelect = () => {

      if (allApplicationsSelect.length > 0) {
        // Copiamos correctamente el array de "allApplicationsSelect"
        const allApplicationsSelectCopy = [...allApplicationsSelect];

   

        // Filtramos quitando las apps que ya están en customerApplications
        const applicationsListSelectFormated = allApplicationsSelectCopy.filter(
          (app: any) =>
            !customerApplications.some((cApp: any) => cApp.id === app.value)
        );

        setCustomerApplicationsSelect(applicationsListSelectFormated);
      }

    };



    const handleDelete = (id:string) => {

      setOpen(true);
      setApplicationRemoveId(id)

    };


    const handleClose = () => {
     setOpen(false);
   };



  const removeApplication = async() => {

    setOpen(false);

    const customerId  = formikProps.values.customerId

    const response = await dispatch( removeApplicationCustomer(applicationRemoveId, customerId) );
    await handleResponse(response, 'Aplicación eliminada con éxito', true);

      if(response.ok){
         setCustomerApplications(response.data);
         formikProps.setFieldValue(e_applications.name, null);
         setBtnAddApplication(false);
      }

  }

  

   const addApplication = async() => {

    
      const dataSave = {
        applicationId: formikProps.values.e_applications,
        customerId:    formikProps.values.customerId
      }
      
      const response = await dispatch( addApplicationToCustomer(dataSave, setPercentaje) );
      await handleResponse(response, 'Aplicación agregada con éxito', true);

    
      if(response.ok){
         setCustomerApplications(response.data);
         formikProps.setFieldValue(e_applications.name, null);
         setBtnAddApplication(false);
      }
    
   }


  const selectApplication = (value: any) => {

    setBtnAddApplication(!!value);
    
  };


  return (
      <>
        {ResponseComponents}
        <Grid container spacing={2}>

             <Grid size={{ xs: 4 }}>
              <InputField 
                name={e_name.name}
                label={e_name.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid size={{ xs: 4 }}>
            <InputField 
                name={e_person_in_charge.name}
                label={e_person_in_charge.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            <Grid size={{ xs: 4 }}>
              <InputField 
                name={e_email.name}
                label={e_email.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

        </Grid>
        {/* END GRID  */}



        <Grid container spacing={2} style={{ marginTop: 15 }}>

 
            <Grid size={{ xs: 4 }}>
                  <AutocompleteFieldCountry
                      options={countries_list}
                      name={e_country.name}
                      label={e_country.label}
                      element={e_country.name}
                  />
            </Grid>
            <Grid size={{ xs: 4 }}>
                  <AutocompleteFieldDepartament 
                      options={departaments}
                      name={e_departament.name}
                      label={e_departament.label}
                      element={e_departament.name}
                  />
            </Grid>
            <Grid size={{ xs: 4 }}> 
                  <AutocompleteField 
                      options={municipaly_list}
                      name={e_municipaly.name}
                      label={e_municipaly.label}
                      element={e_municipaly.name}
                  />
            </Grid>
            

          
            
        </Grid> 
        {/* END GRID  */}


        <Grid container spacing={2} style={{ marginTop: 15 }}>

          
            <Grid size={{ xs: 4 }}>
              <InputNumeric 
                name={e_contact.name}
                label={e_contact.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            
            <Grid size={{ xs: 8 }}>
              <InputField 
                name={e_address.name}
                label={e_address.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
        </Grid> 
        {/* END GRID  */}


        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 4 }}>
              <InputField 
                name={e_second_person_in_charge.name}
                label={e_second_person_in_charge.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid size={{ xs: 4 }}>
              <InputNumeric 
                name={e_second_customer_contact.name}
                label={e_second_customer_contact.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>


         
           <Grid size={{ xs: 4 }}>
              <InputNumeric 
                name={e_phone.name}
                label={e_phone.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            

            
            
            
        </Grid> 
        {/* END GRID  */}



        <Grid container spacing={2} style={{ marginTop: 15 }}>

            <Grid size={{ xs: 4 }}>
              
              <DatePickerDefaultField label={e_start_date.label} 
                               name={e_start_date.name}/>
            </Grid> 


            <Grid size={{ xs: 4 }}>
                <AutocompleteField
                        options={customerApplicationsSelect}
                        name={e_applications.name}
                        label={e_applications.label}
                        element={e_applications.name}
                        onChange={(event:any, value:any) => selectApplication(value)}
                      />
                
                {
                   btnAddApplication && <Button
                                          style={{margin:5, float: 'right'}}
                                          variant="contained"
                                          color={ "success"}
                                          onClick={addApplication}
                                          size='small'
                                        >
                                          Agregar
                                      </Button>
                }
                
            </Grid>

            
            <Grid size={{ xs: 4 }} >

              <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
                {customerApplications.length > 0
                  ? customerApplications.map((application: any) => (
                      <Chip
                        key={application.idCustomerApplication} // Siempre poner key única
                        label={application.name}
                        sx={{ 
                          borderRadius: '8px', 
                          fontWeight: 600, 
                          color: '#765feb',
                          backgroundColor: 'rgba(118, 95, 235, 0.1)',
                          transition: 'all 0.2s',
                          border: '1px solid transparent',
                          '&:hover': {
                            backgroundColor: 'rgba(118, 95, 235, 0.15)',
                            borderColor: 'rgba(118, 95, 235, 0.3)',
                          },
                          '& .MuiChip-deleteIcon': {
                            color: 'rgba(118, 95, 235, 0.5)',
                            transition: 'color 0.2s',
                            '&:hover': {
                              color: '#765feb'
                            }
                          }
                        }}
                        onDelete={() => handleDelete(application.idCustomerApplication)}
                      />
                    ))
                  : null}
              </Stack>


            </Grid>

           

        </Grid>
        {/* END GRID  */}



        <Grid container spacing={2} style={{ marginTop: 15 }}>

            <Grid size={{ xs: 2 }} >
               <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={e_status.name} label={e_status.label}/>
                  <Tooltip title='El cliente esta activo o inactivo.'>
                    <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                  </Tooltip>
                </div>
            </Grid>

        </Grid>
        {/* END GRID  */}

          {customer?.is_trial && (
             <Grid container style={{ marginTop: 20, width: '100%' }}>
                <Grid size={{ xs: 12 }} style={{ width: '100%' }}>
                   <div style={{ backgroundColor: '#E3F2FD', padding: '16px 20px', borderRadius: 8, width: '100%', boxSizing: 'border-box' }}>
                     <span style={{ color: '#0D47A1', fontSize: '1.1rem', fontWeight: 500 }}>
                       Este cliente se encuentra en <b>periodo de prueba</b> hasta el {customer?.trial_ends_at ? new Date(customer.trial_ends_at).toLocaleDateString() : 'N/A'}. 
                     </span>
                     <br/>
                     <span style={{ color: '#0D47A1', fontSize: '1rem', marginTop: '5px', display: 'inline-block' }}>
                       Puede establecer una fecha de pago para la suscripción una vez que finalice.
                     </span>
                   </div>
                </Grid>
             </Grid>
          )}

          {customer?.payment_vencido && (
             <Grid container spacing={2} style={{ marginTop: 15 }}>
                <Grid size={{ xs: 12 }}>
                   <div style={{ backgroundColor: '#FDEDED', padding: 10, borderRadius: 8 }}>
                     <span style={{ color: '#D32F2F', fontSize: '0.9rem', fontWeight: 500 }}>
                       <b>¡El pago de este cliente se encuentra vencido!</b>
                     </span>
                   </div>
                </Grid>
             </Grid>
          )}

        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 4 }}>
              <DatePickerDefaultField 
                label={e_subscription_ends_at.label} 
                name={e_subscription_ends_at.name}
              />
            </Grid>
        </Grid>
        {/* END GRID  */}







          <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Desea eliminar esta applicacion ?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Al eliminar esta aplicacion el cliente no tendra acceso, de igual forma puede volverla a agregar
                  selecionandola en el select de aplicaciones luego en siguiente y guardar.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button
                      style={{margin:5, float: 'right'}}
                      variant="contained"
                      color={ "primary"}
                      onClick={removeApplication}
                    >
                      Aceptar
                  </Button>
                
              </DialogActions>
          </Dialog>



    </>
  )
}

